"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "patient-cards-module" };
var _hoisted_2 = { class: "cards-container" };
var _hoisted_3 = {
    key: 0,
    class: "empty-state"
};
var vue_3 = require("vue");
var axios_1 = require("axios");
var vuex_1 = require("vuex");
var patientCardsStore_ts_1 = require("../../../stores/patientCardsStore.ts"); //'@/stores/patientCardsStore'
var apis_1 = require("@/constants/apis");
var PatientSearchBar_vue_1 = require("./PatientSearchBar.vue");
var PatCard_vue_1 = require("./PatCard.vue");
var PatientEditModal_vue_1 = require("./PatientEditModal.vue");
var EmailComposeModal_vue_1 = require("./EmailComposeModal.vue");
var SmsComposeModal_vue_1 = require("./SmsComposeModal.vue");
var CallComposeModal_vue_1 = require("./CallComposeModal.vue");
var privilegesApi_1 = require("@/api/privilegesApi");
var AppointmentModule_vue_1 = require("./AppointmentModule.vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PatientCards',
    setup: function (__props) {
        var _this = this;
        var pinstore = (0, patientCardsStore_ts_1.usePatientCardsStore)();
        // Access the Vuex store
        var vustore = (0, vuex_1.useStore)();
        // Map Vuex getters
        var allData = (0, vue_3.computed)(function () { return vustore.getters['login/getAllData']; });
        // Computed properties
        var provider = (0, vue_3.computed)(function () { return allData.value.patient; });
        var manager = (0, vue_3.computed)(function () { return allData.value.manager; });
        var relationships = (0, vue_3.computed)(function () { return allData.value.relationDescriptions; });
        var staffContext = (0, vue_3.computed)(function () {
            var _a = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(allData.value), accountnumber = _a.accountnumber, unique_ID = _a.unique_ID;
            return { externId: unique_ID, externId2: accountnumber };
        });
        var editModalOpen = (0, vue_3.ref)(false);
        var AccountType = (0, vue_3.ref)(''); //Account Type | Nice to Have for now
        var provLicense = (0, vue_3.ref)(''); //Provider License | Nice to have for now as well. 
        var emailModalOpen = (0, vue_3.ref)(false);
        var smsModalOpen = (0, vue_3.ref)(false);
        var callModlalOpen = (0, vue_3.ref)(false);
        var appointmentModalOpen = (0, vue_3.ref)(false);
        var selectedPatient = (0, vue_3.ref)(null);
        var fullPatientList = (0, vue_3.ref)([]); // All patients from staff "Patients" proto group (client-side search/filter source)
        var toastMessage = (0, vue_3.ref)('');
        var patients = (0, vue_3.ref)(null);
        var toastType = (0, vue_3.ref)('success');
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            pinstore.loadPatientsFromStaffPatientsGroup(),
                            pinstore.loadProviders()
                        ])];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, pinstore.loadAppointmentsForPatients()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        function openEditModal(patient) {
            selectedPatient.value = patient;
            editModalOpen.value = true;
        }
        function openEmailModal(patient) {
            selectedPatient.value = patient;
            emailModalOpen.value = true;
        }
        function openSmsModal(patient) {
            selectedPatient.value = patient;
            smsModalOpen.value = true;
        }
        function openCallModal(patient) {
            selectedPatient.value = patient;
            callModlalOpen.value = true;
        }
        function openAppointmentModal(patient) {
            selectedPatient.value = patient;
            appointmentModalOpen.value = true;
        }
        function handleScheduled(data) {
            console.log("Appointment scheduled", data);
            showToast("Appointment scheduled for ".concat(data.patientName));
        }
        function handleAppointmentUpdated(data) {
            console.log("Appointment updated", data);
            showToast("Appointment updated for ".concat(data.patientName));
        }
        function handleAppointmentCancelled(data) {
            console.log("Appointment cancelled", data);
            showToast("Appointment cancelled for ".concat(data.patientName), 'info');
        }
        function clearFilters() {
            pinstore.setSearchQuery('');
            pinstore.setFilterTag(null);
        }
        function showToast(message, type) {
            if (type === void 0) { type = 'success'; }
            toastMessage.value = message;
            toastType.value = type;
            setTimeout(function () {
                toastMessage.value = '';
            }, 3000);
        }
        function handlePatientSaved() {
            showToast('Patient demographics updated successfully');
        }
        function handleEmailSent(data) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    //original function params { to: string; subject: string }
                    console.log("Compose Email FormData Object Sent Via Emit");
                    console.log(data);
                    console.log("Find Provider Bro");
                    console.log(manager);
                    //lets send the actual email via axios
                    axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", data)
                        .then(function (res) {
                        if (res.data.message == "EmailSent") {
                            alert("Emails successfully sent ");
                        }
                    })
                        .catch(function (err) {
                        console.log("GetPatient Error");
                        console.log(err);
                        fullPatientList.value = [];
                        // this.allProvs = null;
                        AccountType.value = "";
                        provLicense.value = "";
                    });
                    showToast("Email sent to ".concat(data.patientName));
                    return [2 /*return*/];
                });
            });
        }
        function handleSmsSent(data) {
            showToast("SMS sent to ".concat(data.to));
        }
        function handleCallSent(data) {
            alert("CLicked");
            showToast("Call sent to ".concat(data.to));
        }
        function loadPatientsFromStaffPatientsGroup() {
            return __awaiter(this, void 0, void 0, function () {
                var ctx, content;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            ctx = staffContext.value;
                            if (!ctx.externId || !ctx.externId2) {
                                fullPatientList.value = [];
                                return [2 /*return*/];
                            }
                            content = {
                                Patients: {
                                    API_Meth: "GetPatientsFromStaffPatientsGroup",
                                    accountnumber: ctx.externId2,
                                    staff_unique_ID: String(ctx.externId),
                                }
                            };
                            return [4 /*yield*/, axios_1.default
                                    .post(apis_1.CURR_API + "/tswebhook.php", content, {
                                    headers: { "Content-Type": "application/json;" },
                                })
                                    .then(function (res) {
                                    var pts = res.data.patients && Array.isArray(res.data.patients) ? res.data.patients : [];
                                    fullPatientList.value = pts;
                                    AccountType.value = res.data.accountType || "";
                                    provLicense.value = res.data.provLicense || "";
                                    //this.allProvs = pts.length > 0 ? pts : null;
                                })
                                    .catch(function (err) {
                                    console.log("GetPatient Error");
                                    console.log(err);
                                    fullPatientList.value = [];
                                    // this.allProvs = null;
                                    AccountType.value = "";
                                    provLicense.value = "";
                                })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(PatientSearchBar_vue_1.default),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)(vue_2.TransitionGroup, {
                        name: "card-list",
                        tag: "div",
                        class: "cards-grid"
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(pinstore).filteredPatients, function (patient) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(PatCard_vue_1.default, {
                                    key: patient.id,
                                    patient: patient,
                                    onEdit: openEditModal,
                                    onEmail: openEmailModal,
                                    onSms: openSmsModal,
                                    onCall: openCallModal,
                                    onAppointment: openAppointmentModal
                                }, null, 8, ["patient"]));
                            }), 128))
                        ]; }, undefined, true),
                        _: 1
                    }),
                    ((0, vue_2.unref)(pinstore).filteredPatients.length === 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                            _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-search" }, null, -1)),
                            _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("h3", null, "No patients found", -1)),
                            _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("p", null, "Try adjusting your search or filter criteria", -1)),
                            ((0, vue_2.unref)(pinstore).searchQuery || (0, vue_2.unref)(pinstore).filterTag)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                    key: 0,
                                    class: "btn-clear",
                                    onClick: clearFilters
                                }, " Clear Filters "))
                                : (0, vue_2.createCommentVNode)("", true)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createVNode)(PatientEditModal_vue_1.default, {
                    show: editModalOpen.value,
                    patient: selectedPatient.value,
                    onClose: _cache[0] || (_cache[0] = function ($event) { return (editModalOpen.value = false); }),
                    onSaved: handlePatientSaved
                }, null, 8, ["show", "patient"]),
                (0, vue_2.createVNode)(EmailComposeModal_vue_1.default, {
                    show: emailModalOpen.value,
                    patient: selectedPatient.value,
                    provider: (0, vue_2.unref)(pinstore).currentProvider,
                    onClose: _cache[1] || (_cache[1] = function ($event) { return (emailModalOpen.value = false); }),
                    onSent: handleEmailSent
                }, null, 8, ["show", "patient", "provider"]),
                (0, vue_2.createVNode)(SmsComposeModal_vue_1.default, {
                    show: smsModalOpen.value,
                    patient: selectedPatient.value,
                    provider: (0, vue_2.unref)(pinstore).currentProvider,
                    onClose: _cache[2] || (_cache[2] = function ($event) { return (smsModalOpen.value = false); }),
                    onSent: handleSmsSent
                }, null, 8, ["show", "patient", "provider"]),
                (0, vue_2.createVNode)(CallComposeModal_vue_1.default, {
                    show: callModlalOpen.value,
                    patient: selectedPatient.value,
                    provider: (0, vue_2.unref)(pinstore).currentProvider,
                    onClose: _cache[3] || (_cache[3] = function ($event) { return (callModlalOpen.value = false); }),
                    onCallsent: handleCallSent
                }, null, 8, ["show", "patient", "provider"]),
                (0, vue_2.createVNode)(AppointmentModule_vue_1.default, {
                    show: appointmentModalOpen.value,
                    patient: selectedPatient.value,
                    provider: (0, vue_2.unref)(pinstore).currentProvider,
                    onScheduled: handleScheduled,
                    onUpdated: handleAppointmentUpdated,
                    onCancelled: handleAppointmentCancelled,
                    onClose: _cache[4] || (_cache[4] = function ($event) { return (appointmentModalOpen.value = false); })
                }, null, 8, ["show", "patient", "provider"]),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "toast" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (toastMessage.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: (0, vue_2.normalizeClass)(["toast", toastType.value])
                            }, [
                                (0, vue_2.createElementVNode)("span", {
                                    class: (0, vue_2.normalizeClass)(["glyphicon", toastType.value === 'success' ? 'glyphicon-ok-circle bi-check-circle-fill' : 'glyphicon-info-sign'])
                                }, null, 2),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(toastMessage.value), 1)
                            ], 2))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
